require('es6-promise').polyfill();
import svg4everybody from 'svg4everybody';
import './polyfills';
import 'jquery-mousewheel';
import 'jquery.csssr.validation';
import '../blocks/main';
import 'jquery.inputmask/dist/jquery.inputmask.bundle';
import accordeon from '../blocks/accordeon/accordeon';
import tabs from '../blocks/tabs/tabs';
import select from '../blocks/select';
import cardRates from '../blocks/card-rates/card-rates';
import adaptive from '../blocks/adaptive';
import mainReviews from '../blocks/main-reviews';
import preview from '../blocks/site/';
import mainAnimation from '../blocks/main';
import sliderDesign from '../blocks/stylish-design/stylish-design';
import example from '../blocks/example/example';
import teamCard from '../blocks/team-card/';
import macSlider from '../blocks/mac-slider/mac-slider';
import infoCard from '../blocks/info-card/info-card';
import guide from '../blocks/guide/guide';
import tooltip from '../blocks/tooltip/tooltip';
import contactsMap from '../blocks/contacts/contacts';
import vacancyCard from '../blocks/vacancy-card/vacancy-card';
import support from '../blocks/support/support';
import clients from '../blocks/clients/clients';
import templates from '../blocks/templates/templates';
import field from '../blocks/field/';
import reviews from '../blocks/reviews';
import scrollToTop from '../blocks/scrolltop/scrolltop';
import avatar from '../blocks/avatar/';
import PopupHeader from '../blocks/header/header';
import SignupForm from '../blocks/signup-form/signup-form';
import catalogDesign from '../blocks/catalog-design/catalog-design';
import login from '../blocks/login/login';
import signUp from '../blocks/sign-up/signUp';
import fixIphoneScroll from './fixIphoneScroll';
import price from '../blocks/price/price';
import promokod from '../blocks/promokod/promokod';
import isRetina from '../blocks/is-retina/is-retina';
import promocodeShare from '../blocks/promocodeshare/promocodeshare';
import faqPage from '../blocks/faq-page/faq-page';
import banner from '../blocks/banner/banner'; // banner
import fullBgImage from '../blocks/full-bg-img/full-bg-img';
import unsubscribeForm from '../blocks/unsubscribe-form/unsubscribe-form';
import footer from '../blocks/footer/footer';
import mainHeaderSlider from '../blocks/main-slider/main-slider';
import mainMenu from '../blocks/menu-main/main-menu';
import sitesSlider from '../blocks/sites-slider/sites-slider';
import galleriesMain from '../blocks/galleries-main/galleries-main';
import reviewsSlider from '../blocks/reviews-slider/reviews-slider';
import langNavi from '../blocks/lang-navi/lang-navi';
import btnSplitText from '../blocks/button/btn-style';
import inputPlaceholder from '../blocks/input-placeholder/input-placeholder';
import priceGallery from '../blocks/price-gallery/price-gallery';
import printGallery from '../blocks/print-galleries/print-galleries';
import examplesSlider from '../blocks/gallery-examples/gallery-examples';
import retouchPage from '../blocks/retouch/retouch';
import retouchBaSlider from '../blocks/retouch/retouch-ba-slider';
import retouchTariffs from '../blocks/retouch/retouch-tariffs';
import anchorScroll from './anchor-scroll';

function mainController(fn, controller) {
	// console.log( document.body.querySelectorAll(controller), document.body.querySelectorAll(controller).length);
	if (document.body.querySelectorAll(controller).length > 0) {
		// console.log(controller + ' init');
		fn();
	}
	else {
		// console.log(controller + ' not found');
	}
}

const init = () => {
	svg4everybody();
	isRetina();

	if (window.bannerState === true) {
		mainController(banner, '.js--banner'); // banner
	}
	mainController(mainMenu, '.js--main-menu');
	mainController(accordeon, '.js-accordeon');
	mainController(tabs, '.js-tabs');
	mainController(select, '.js-select');
	mainController(cardRates, '.js-price-card');
	mainController(mainReviews, '#slider-review');
	mainController(preview, '.js-preview');

	adaptive();

	mainController(mainAnimation, '.js-main-page');
	mainController(sliderDesign, '#slider-design');
	mainController(example, '.js-example');
	mainController(macSlider, '#mac-slider');
	mainController(mainHeaderSlider, '.js--with-slider__header');
	mainController(infoCard, '.js-info-card');
	// mainController(guide, '.js-guide-page');
	guide();
	mainController(teamCard, '.js-team-card');
	mainController(tooltip, '.js-tooltip');
	mainController(contactsMap, '.js-contacts');
	mainController(vacancyCard, '.js-vacancy-card');
	mainController(support, '.js-support');
	mainController(clients, '.js-clients');
	mainController(templates, '.js-templates');
	mainController(sitesSlider, '.js--sites-slider');
	mainController(galleriesMain, '.js--galleries-preview');
	mainController(reviewsSlider, '.js--reviews-slider');
	mainController(langNavi, '.js--lang-navi');
	mainController(btnSplitText, '.js--btn-style');
	mainController(inputPlaceholder, '.js--input-with-placeholder');
	mainController(priceGallery, '.js--tariff-tab');
	mainController(printGallery, '.js--print-galleries');
	mainController(examplesSlider, '.js--examples-slider');
	mainController(anchorScroll, '.js--anchor');
	mainController(retouchPage, '.js-retouch-page');
	mainController(retouchBaSlider, '.js--retouch__ba-slider');
	mainController(retouchTariffs, '.js--retouch__tariffs');

	field();

	mainController(reviews, '.js-review-form');

	scrollToTop();

	mainController(avatar, '.js-avatar');
	mainController(login, '.js-login');
	mainController(signUp, '.js-sign-up');
	mainController(catalogDesign, '.js-catalog-design');
	mainController(fixIphoneScroll, '.scrollable');
	mainController(price, '.js-price');
	mainController(promokod, '.js-promocode');
	mainController(promocodeShare, '.js--promocodeShare');
	mainController(faqPage, '.js-faq-page');
	mainController(fullBgImage, '.js-full-bg-img');
	mainController(unsubscribeForm, '.js-unsubscribe-form__subscribe-btn');
	mainController(footer, '.js--lang-redirect-event');

	// эти вызовы надо переписать
	if (document.body.querySelectorAll('.js-header').length > 0) {
		new PopupHeader().render();
	}
	if (document.body.querySelectorAll('.js-signup-form').length > 0) {
		new SignupForm().render();
	}

};

export default init;



// WEBPACK FOOTER //
// ./app/scripts/init.js